module.exports = __webpack_public_path__ + "static/media/BetaBanner.6182e93b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/BetaBanner.jpg
// module id = 202
// module chunks = 0